import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type CandidateInsight = {
  id: string;
  title: string;
  value: string;
  description: string;
  highlights: string[];
  icon?: string;
};

export type CandidateAnnouncement = {
  id: string;
  title: string;
  body: string;
  ctaLabel?: string;
  ctaLink?: string;
  severity?: 'info' | 'success' | 'warning' | 'error';
};

export type CandidateTrainingRecommendation = {
  id: string;
  title: string;
  provider: string;
  duration: string;
  price: string;
  link?: string;
};

export type CandidateDashboardSummary = {
  insights: CandidateInsight[];
  announcements: CandidateAnnouncement[];
  training: CandidateTrainingRecommendation[];
};

export async function fetchCandidateDashboardSummary(): Promise<CandidateDashboardSummary> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to load candidate dashboard data.');
  }

  const response = await fetchWithAuth(`${API_BASE_URL}/v1/candidate/dashboard`);
  if (!response.ok) {
    throw new Error(`Candidate dashboard fetch failed (${response.status})`);
  }
  const payload = await response.json();
  if (!payload?.insights && !payload?.announcements && !payload?.training) {
    throw new Error('Candidate dashboard response malformed.');
  }
  return {
    insights: payload.insights ?? [],
    announcements: payload.announcements ?? [],
    training: payload.training ?? [],
  };
}
